export enum Mutations {
    // Auth mutations - magic link implementation
    checkEmail = 'checkEmail',
    signup = 'signup',
    organizationSignup = 'organizationSignup',
    exchangeMagicToken = 'exchangeMagicToken',
    refreshToken = 'refreshToken',
    logout = 'logout',
    logoutAll = 'logoutAll',

    // Feedback mutations
    submitFeedback = 'submitFeedback',

    // HRIS mutations
    uploadHRISFile = 'uploadHRISFile',
    updateFieldMappings = 'updateFieldMappings',
    updateSingleFieldMapping = 'updateSingleFieldMapping',
    confirmMappings = 'confirmMappings',

    // Notification mutations
    dismissNotification = 'dismissNotification',
    dismissAllNotifications = 'dismissAllNotifications',

    // Notification Settings mutations
    updateNotificationSettings = 'updateNotificationSettings',

    // Intake survey mutations
    submitIntakeSurvey = 'submitIntakeSurvey',
    submitManagerIntakeSurvey = 'submitManagerIntakeSurvey',

    // HR Intake mutations
    submitHRIntakeForm = 'submitHRIntakeForm',
    updateHRIntakeForm = 'updateHRIntakeForm',

    // User Management mutations
    updateUserProfile = 'updateUserProfile',
    uploadProfilePicture = 'uploadProfilePicture',
    removeProfilePicture = 'removeProfilePicture',
    inviteUser = 'inviteUser',
}
